import styled from 'styled-components';

export const CustomerServiceContainer = styled.div`
    width: 232px;
    max-height: 340px;
    flex: 0 0 auto !important;
    text-align: center;
    background: ${props => props.theme.customerServiceBlockBackground};
    padding: 25px 15px;
    margin-left: 30px;

    .titre {
        font-weight: ${props => props.theme.boldWeight};
        text-transform: uppercase;
    }
    .titre:after {
        content: '';
        display: block;
        width: 60px;
        height: 2px;
        margin: 20px auto 0;
        background: ${props => props.theme.h2BorderColor};
    }
    .text {
        padding: 23px 30px;
    }

    .text p {
        line-height: 1.8;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        width: 100%;
        margin: auto;
        margin-top: 25px;

        &.merchantCard {
            margin-top: 0;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/CustomerServiceComponentStyle.js